import React from 'react';

import { getUserInfo } from '@/utils/Util';

const OrderDetailsTabs = ({
	type,
	currentStep,
	isDrafted,
	orderPlaceMentStatus,
	orderCancelInfo,
	onChangeStep
}) => {
	const userInfo = getUserInfo();
	const alwaysExcludedSteps = ['SALES_CONTRACT', 'COMMERCIAL_INVOICE', 'PAYMENT_TRACKER'];
	const orderPlacementStatusList = (
		type === 'PENDING'
			? orderPlaceMentStatus.filter(
					(item) => !['COMMERCIAL_INVOICE', 'PAYMENT_TRACKER'].includes(item.workflowStep)
				)
			: orderPlaceMentStatus
					.filter((item) => {
						if (item.workflowStep === 'TEAM') {
							return userInfo.userLevelName === 'Software Engineer';
						}
						return true;
					})
					.filter((item) => {
						if (orderCancelInfo.status === 'APPROVED') {
							return ['ORDER_INFO'].includes(item.workflowStep);
						} else {
							return true;
						}
					})
	).filter((item) => !alwaysExcludedSteps.includes(item.workflowStep));
	return (
		<>
			{!isDrafted && (
				<div className="order-details-sidebar orderer-details-pending-sidebar">
					<ul className="d-flex flex-wrap">
						{orderPlacementStatusList?.map((item) => (
							<li
								key={item.workflowStep}
								className={`d-flex align-items-center align-self-center ${currentStep === item.stepName ? 'selected' : ''}`}
								onClick={() => onChangeStep(item)}
							>
								{item.stepName}
							</li>
						))}
					</ul>
				</div>
			)}
		</>
	);
};

export default OrderDetailsTabs;
